import { RouteType } from "types/RouteType";
import WarrantyClaimWizardStore from "./WarrantyClaimWizardStore";

const WarrantyClaimWizardRoute: RouteType = {
  name: "WarrantyClaimWizard",
  path: "/workflows/warranty-claim",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Warranty Claim & Service",
      component: () => import("./WarrantyClaimWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./WarrantyClaimWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.warrantyClaimWizardStore) {
      rootStore.warrantyClaimWizardStore = new WarrantyClaimWizardStore(
        rootStore
      );
    }
    await rootStore.warrantyClaimWizardStore.loadInitialData();
    return true;
  },
};

export default WarrantyClaimWizardRoute;